export const PAYMENT_PREFIX = '@payment/';
export const PAYMENT_PAY_BY_CARD = `${PAYMENT_PREFIX}PAY_BY_CARD`;
export const PAYMENT_CLEAR = `${PAYMENT_PREFIX}CLEAR`;
